import type { FC } from 'react';
import GreyBorderedBox from '../components/grey-bordered-box';
import BulletList from '../components/bullet-list';
import AttentionBox from '../components/attention-box';
import ActionButton from '../components/action-button';
import NoticeSection from '../components/notice-section';
import styles from '../styles/end-user-booking-notice.module.scss';

const EndUserBookingNotice: FC<{
    available: boolean;
    messages: string[];
    onProceed: () => void;
}> = ({ available, messages, onProceed }) => {
    return (
        <div className={styles.endUserBookingNotice}>
            {available && (
                <ActionButton
                    className={styles.proceedButton}
                    title="来店予約はこちら"
                    onClick={onProceed}
                />
            )}
            <div className={styles.information}>
                本ページを含む以降の予約画面は、スマホ修理工房が運営するサイトです。
            </div>
            <div className={styles.storefrontSection}>
                <img
                    className={styles.image}
                    src="/static/img/usol_repair/storefront.png"
                    alt="スマホ修理工房"
                />
                <p className={styles.description}>
                    スマホ修理工房は、グローバルリペアネットワークを展開するAssurantグループが運営しています。全国で拡大展開中。最寄りの店舗にて、機種・修理内容をご確認の上、ご予約をお申し込みください。
                </p>
                <p className={styles.note}>
                    ※au/UQ mobileでご購入いただいた対象機種はメーカー純正部品で修理を行います
                </p>
            </div>
            <AttentionBox title="お客さまへのお知らせ" messages={messages} />
            <GreyBorderedBox className={styles.description}>
                <NoticeSection title="■ご予約前にご確認ください">
                    <BulletList>
                        <li>
                            ご案内メールは
                            <span className={styles.highlight}>「@u-phone.net」ドメイン</span>
                            から送信いたします。迷惑メール設定等により受信できない場合がございますので、
                            <span className={styles.highlight}>
                                事前に受信許可設定をお願いいたします。
                            </span>
                        </li>
                        <li>
                            やむを得ずご予約をお受けできない場合は、事前にメールにてご連絡いたします。
                        </li>
                    </BulletList>
                </NoticeSection>
                <NoticeSection title="■店頭即時修理について">
                    対象機種（対応機種一覧に記載の機種）かつ対象の修理内容の場合のみ、ご予約いただけます。
                    詳しくは
                    <a
                        className={styles.noticeLink}
                        href="https://www.au.com/support/service/mobile/trouble/repair-android/"
                        target="_blank"
                    >
                        こちら
                    </a>
                    でご確認ください
                </NoticeSection>
                <NoticeSection title="■店頭即時修理ができない主なケース">
                    以下の場合は、修理サービスをご提供できないことがございます。あらかじめご了承ください。
                    <BulletList>
                        <li>修理前の事前診断ができない場合</li>
                        <li>対象の修理内容以外に破損がある場合</li>
                        <li>修理部品の在庫がない場合</li>
                    </BulletList>
                </NoticeSection>
                <NoticeSection title="■ご予約時の注意事項">
                    <BulletList>
                        <li>
                            お申込手続き中にブラウザや携帯電話の「戻る」ボタンを押すと、入力内容が消える場合がありますのでご注意ください。
                        </li>
                        <li>
                            手続きが完了しない状態となった場合は、お手数ですが一度ブラウザを閉じてから、再度手続きをお願いいたします。
                        </li>
                    </BulletList>
                </NoticeSection>
                <NoticeSection title="■推奨環境（ブラウザ）">
                    <BulletList>
                        <li>
                            最新のブラウザにアップデートしてご利用ください。古いバージョンや特定の設定では、正しく表示されない場合がございます。
                        </li>
                        <li>正常に表示されない場合は、別のブラウザでのご利用をお試しください。</li>
                    </BulletList>
                </NoticeSection>
            </GreyBorderedBox>
        </div>
    );
};

export default EndUserBookingNotice;
